import classes from './TileSection.module.css'
import { RoleRoute, TileRoleRoute } from '@/types'
import { Tile } from '@/routes/admin/components/Tile/Tile'
import { isUserRoleAllowed } from '@/routes/utils'
import { RolesDescriptor } from '@/auth/azure/Roles'

const getItemPath = (item: TileRoleRoute, tile: TileRoleRoute) => {
  if (!item.path) {
    return '/admin'
  }

  const tilePath = tile.path ? `/${tile.path}` : ''
  return item.path + tilePath
}

export const TileSection = (item: RoleRoute, roles: RolesDescriptor | undefined) => {
  const tiles: TileRoleRoute[] | undefined = item.children?.filter(
    (childRoute: TileRoleRoute) => childRoute.tile && isUserRoleAllowed(roles, childRoute.allowedRoles),
  )
  return (
    <div className={classes.tileSection}>
      {tiles
        ? tiles.map((tile: TileRoleRoute, i) => <Tile key={i} path={getItemPath(item, tile)} item={tile} />)
        : null}
    </div>
  )
}
